/**
 * Normalises any Responsibility row/card shape into the `responsibility` object the
 * RenameResponsibilityDialog expects: { id, name, context?, status, archived }.
 * `context` is left undefined when the source does not carry it, so the dialog
 * loads the current Context itself instead of pre-filling an empty one.
 */
export function toRenameResponsibilityModel(source) {
  if (!source) return null;
  const data = source.data || {};
  const info = source.info || {};
  const context = [source.context, data.context, info.context].find(
    (value) => value !== undefined
  );

  return {
    id: source.realId ?? source.id ?? data.id ?? null,
    name: data.name ?? source.name ?? "",
    ...(context === undefined ? {} : { context: context ?? "" }),
    status: data.status ?? source.status ?? "",
    archived: Boolean(source.archived ?? data.archived ?? info.archived),
  };
}
